<template>
  <div class="page">
    <div class="empty" />
    <div class="container">
      <img class="icon" src="@/assets/invite/img_0.png" />
      <span class="title">推荐好友注册</span>
      <span class="caption">赚取高额佣金</span>
    </div>

    <!-- <van-cell-group style="margin: 0 auto;width: 90%;">
      <van-field v-model="value" placeholder="填写推荐码" />
    </van-cell-group>
    <van-button style="margin: 0 auto;">确认</van-button> -->

    <div class="container-2">
      <div class="overlayer-1" />
      <div class="primary-1">
        <div class="info-wrapper">
          <span class="info">邀请好友扫码注册</span>
        </div>
        <span class="desc">好友成功注册下单后，赚取奖金</span>
        <div class="group-1">
          <img v-if="qrcode" class="icon-3" :src="qrcode" />
        </div>
        <!-- <div class="tag-wrapper"><span class="tag-1">扫一扫</span></div> -->
      </div>
    </div>
    <van-divider :margin="5" />
    <van-cell-group style="margin: 0 auto; width: 90%">
      <van-cell title="我的邀请码" v-model="info.inviteCode" />
      <van-cell v-if="nickname" title="邀请人" v-model="nickname" />
      <van-cell title="我的推广业绩" v-model="relations.recommendPerformance" />
    </van-cell-group>
    <van-divider :margin="5" />
    <van-cell-group style="margin: 0 auto; width: 90%">
      <template v-for="item in nodeList">
        <van-cell title="下级" v-model="item.account">

        </van-cell>
        <van-cell title="下级" v-model="item.account">

</van-cell>
<van-cell title="下级" v-model="item.account">

</van-cell>
<van-cell title="下级" v-model="item.account">

</van-cell>
      </template>
    </van-cell-group>
    
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      constants: {},
      invite_code: "123456",
      info: {},
      nickname: "",
      value: "",
      qrcode: "",
      relations: {},
      nodeList: [],
    };
  },
  created: function () {
    this.init();
    this.getJssdkConfig();
    console.log("htest");
    console.log(this.$route.params.invitedFrom);
  },
  methods: {
    init() {
      var _this = this;
      this.$post({
        module: "User",
        interface: "1000",
        data: {},
      }).then((res) => {
        console.log(res);
        this.info = res;
      });
      
      this.$post({
        module: "Account",
        interface: "4000",
        data: {},
      }).then((res) => {
        console.log(res);
        _this.qrcode = res.qrcode;
        _this.relations = res.relations;
      });

      // this.$post({
      //   module: "User",
      //   interface: "4100",
      //   data: {},
      // }).then((res) => {
      //   console.log(res);
      // });

      // this.$post({
      //   module: "User",
      //   interface: "4101",
      //   data: {
      //     page: 1,
      //     lastId: 0,
      //   },
      // }).then((res) => {
      //   console.log(res);
      // });

      this.$post({
        module: "User",
        interface: "4102",
        data: {},
      }).then((res) => {
        console.log(res);
        this.nodeList = res.nodeList;
      });

      // this.$post({
      //   module: "User",
      //   interface: "4103",
      //   data: {},
      // }).then((res) => {
      //   console.log(res);
      // });

      if (this.$route.params && this.$route.params.invitedFrom) {
        this.$post({
          module: "Account",
          interface: "4001",
          data: {
            inviteCode: this.$route.params.invitedFrom,
          },
        }).then((res) => {
          console.log(res["nickname"]);
          _this.nickname = res["nickname"];
          console.log(_this.nickname);
        });

        // this.$post({
        //   module: "Account",
        //   interface: "4002",
        //   data: {
        //     "inviteCode": this.$route.params.invitedFrom,
        //   },
        // }).then((res) => {
        //   console.log(res['nickname']);
        //   _this.nickname = res['nickname']
        //   console.log(_this.nickname)
        // });
      }
    },
    getJssdkConfig() {
      var _this = this;
      var url_list = window.location.href.split("#");
      var path0 = url_list[0];
      var path1 = url_list[1];
      url_list = path0.split("?");
      var timestamp = new Date().valueOf();
      this.$post({
        url: "/portal/Wechat",
        module: "Index",
        interface: "1001",
        data: {
          pageUrl: path0,
        },
      }).then((res) => {
        console.log("1.0 jssdk", res);
        // res.debug = true;
        wx.config(res);
        // wx.error(function (res) {
        // 	console.log(res);
        // });
        wx.ready(function () {
          //需在用户可能点击分享按钮前就先调用
          wx.updateAppMessageShareData({
            title: "波波购注册邀请", // 分享标题
            desc: "邀请好友下单获取奖金", // 分享描述
            // link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            link: url_list[0] + "?time=" + timestamp + "&path=" + path1,
            imgUrl: "https:" + _this.info.thumb, // 分享图标
            success: function () {
              console.log("success");
            },
            fail: function () {
              console.log("fail");
            },
          });
        });
      });
    },
  },
};
</script>

<style src="./index.css" />
;
